import { render, staticRenderFns } from "./BaseIconButton.vue?vue&type=template&id=365b4dbc&scoped=true&"
import script from "./BaseIconButton.vue?vue&type=script&lang=js&"
export * from "./BaseIconButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseIconButton.vue?vue&type=style&index=0&id=365b4dbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b4dbc",
  null
  
)

export default component.exports